<div class="page-container">
    <img class="page-img" src="../../../assets/images/404-page-not-found.svg">
    <h2>Oops! Page not found</h2>
    <p>The page you have requested could not be found</p>
    <button class="go-back" routerLink="../login">GO BACK</button>
</div>